export const getUniqueSrcImg = (src) => src + "?v=" + Math.random();
